import { getProductionComponentInstancesByProductionGroupGuid } from '../selectors/getProductionComponentInstancesByProductionGroupGuid';
import { loadBatchesForProductionGroup } from './batchActions';
import { loadBundlesForProductionGroup } from './bundleActions';
import { loadProductionComponentInstancesForProductionGroup } from './productionComponentInstances';
import { AsyncThunkActionVoid } from './thunkActions';

export function loadProductionGroupData(productionGroupGuid: string, spinner = true): AsyncThunkActionVoid {
  return async function loadProductionGroupDataThunkAction(dispatch, getState) {
    const productionComponentInstancesByProductionGroupGuid =
      getProductionComponentInstancesByProductionGroupGuid(getState());
    if (productionComponentInstancesByProductionGroupGuid[productionGroupGuid]?.length > 0) return;

    const loadBatchesPromise = dispatch(loadBatchesForProductionGroup(productionGroupGuid, spinner));
    const loadBundlesPromise = dispatch(loadBundlesForProductionGroup(productionGroupGuid, spinner));
    const loadProductionComponentInstancesPromise = dispatch(
      loadProductionComponentInstancesForProductionGroup(productionGroupGuid, spinner),
    );
    await Promise.all([loadBatchesPromise, loadBundlesPromise, loadProductionComponentInstancesPromise]);
  };
}
